
















/**
 * Text-based tabs
 *
 * Set aria-label on this in the parent component.
 */
import { Vue, Component, Prop } from 'vue-property-decorator'
import { navigateTo } from 'bits/location'

export interface BaseTextTabsTab {
  key: number
  text: string
  href?: string
}

export enum Size {
  default = 'default',
  small = 'small',
}

export enum Font {
  default = 'default',
  caps = 'caps',
}

export enum WidthFitting {
  none = 'none',
  fit = 'fit',
  scroll = 'scroll',
}

export enum HeightFitting {
  none = 'none',
  fit = 'fit',
}

@Component
export default class BaseTextTabs extends Vue {
  @Prop({ default: () => [] }) tabs!: BaseTextTabsTab[]
  @Prop({ default: null }) activeKey
  @Prop({ default: WidthFitting.fit }) widthFitting
  @Prop({ default: HeightFitting.fit }) heightFitting
  @Prop({ default: Size.default }) size
  @Prop({ default: Font.caps }) font
  @Prop({ default: null }) clickHandler

  get containerClasses(): string[] {
    const classes = ['tabs-container']
    if (this.widthFitting === WidthFitting.scroll) classes.push('scroll-width')
    if (this.widthFitting === WidthFitting.fit) classes.push('fit-width')
    if (this.heightFitting === HeightFitting.fit) classes.push('fit-height')
    if (this.size === Size.small) classes.push('tabs-small')
    if (this.font === Font.caps) classes.push('tabs-caps')
    return classes
  }

  onTabClick(tab): void {
    if (this.clickHandler) {
      this.clickHandler(tab.key)
    } else {
      navigateTo(tab.href)
    }
  }
}
